export const SET_LINKS = "SET_LINKS";
export const ADD_LINKS = "ADD_LINKS";
